import { AdvancingTemplateDetailSection } from "../AdvancingTemplateDetailSection";
import AdvancingTemplateOptionsPanel from "../AdvancingTemplateOptionsPanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import SupportArticlePanel from "components/SupportArticlePanel/SupportArticlePanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";

const AdvancingTemplateDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.AdvancingFormTemplateFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <AdvancingTemplateDetailSection
            advancingTemplate={viewModel.template}
            allFormSections={viewModel.formSections}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <AdvancingTemplateOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            advancingTemplateId={viewModel.template.advancingFormTemplateId}
          />
          <SupportArticlePanel
            config={viewModel.articlePanelConfig}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
}

export default AdvancingTemplateDetailApp;